/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ZteTableFragmentDoc } from '../../../../../components/organization/ZteTable/__generated__/ZteTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ZtePageQueryVariables = Types.Exact<{
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  filter?: Types.InputMaybe<Types.ZteEnrolmentFiltersInput>;
}>;


export type ZtePageQuery = { __typename: 'Query', enrolmentsForOrganization: { __typename: 'QueryEnrolmentsForOrganizationPayload', totalCount: number, zteFilters: { __typename: 'ZteFilters', modelNumbers: Array<string>, customers: Array<{ __typename: 'ZteCustomerFilter', id: string, name: string }>, batches: Array<{ __typename: 'ZteBatchFilter', id: string, name: string }> }, zteEnrolment: Array<{ __typename: 'ZteEnrolment', id: string, alias?: string | null, batchName?: string | null, serialNumber?: string | null, status: string, macAddress?: string | null, customerId?: string | null, customerName?: string | null, createdAt: any, assignedAt?: any | null, modelNumber?: string | null, firmwareVersion?: string | null }> } };


export const ZtePageDocument = gql`
    query ZtePage($pageNumber: Int, $pageSize: Int, $searchTerm: String, $filter: ZteEnrolmentFiltersInput) {
  enrolmentsForOrganization(
    pageNumber: $pageNumber
    pageSize: $pageSize
    searchTerm: $searchTerm
    filter: $filter
  ) {
    zteFilters {
      customers {
        id
        name
      }
      batches {
        id
        name
      }
      modelNumbers
    }
    zteEnrolment {
      ...ZteTable
    }
    totalCount
  }
}
    ${ZteTableFragmentDoc}`;

/**
 * __useZtePageQuery__
 *
 * To run a query within a React component, call `useZtePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useZtePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZtePageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      searchTerm: // value for 'searchTerm'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useZtePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ZtePageQuery, ZtePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZtePageQuery, ZtePageQueryVariables>(ZtePageDocument, options);
      }
export function useZtePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZtePageQuery, ZtePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZtePageQuery, ZtePageQueryVariables>(ZtePageDocument, options);
        }
export type ZtePageQueryHookResult = ReturnType<typeof useZtePageQuery>;
export type ZtePageLazyQueryHookResult = ReturnType<typeof useZtePageLazyQuery>;
export type ZtePageQueryResult = ApolloReactCommon.QueryResult<ZtePageQuery, ZtePageQueryVariables>;